import React from 'react'
import {
  CFView,
  CFImage,
  CFText,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { mobilePromotion, promotions, skip, doordash, uber } from 'images'
import OrderPickupButton from './OrderPickupButton'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center mt="10px" textCenter>
          <CFView column center w="100%" zIndex={90}>
            <CFText h1 white xBold>
              ORDER ONLINE NOW!
            </CFText>
            <CFView pulsate mt="15px">
              <OrderPickupButton />
            </CFView>
          </CFView>
          <CFImage src={mobilePromotion} w="100%" alt="Promotions" />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView column center m="0 auto" maxWidth="1400px">
          <CFView row center w="80%" zIndex={90}>
            <CFText h1 white xBold>
              ORDER ONLINE NOW!
            </CFText>
            <CFView pulsate ml="25px">
              <OrderPickupButton />
            </CFView>
          </CFView>
          <CFImage mt="-70px" src={promotions} w="100%" alt="Promotions" />
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
